import React, { useState, useEffect } from 'react'
import { suggestionListService, authService } from '../../_services'
import { Button, Modal, Spinner, Form } from 'react-bootstrap'
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faCheck } from '@fortawesome/free-solid-svg-icons'
import moment from 'moment'
import Select from 'react-select'
import { SERVER_URL } from '../../config';
import { v4 as uuidv4 } from 'uuid';

function MultiSuggestion(props) {

	const [show, setShow] = useState(false)
	const [text, setText] = useState("")
	const [searchQuery, setSearchQuery] = useState("")
	const [suggestionLists, setSuggestionLists] = useState([])
	const [selectedLists, setSelectedLists] = useState([])
	const [results, setResults] = useState([])
	const [stage, setStage] = useState('FORM')
	const [listUpdateSuccess, setListUpdateSuccess] = useState({})
    const {t} = useTranslation('common')

	const onClick = () => {
		setText('')
		setSuggestionLists([])
		setSearchQuery('')
        setSelectedLists([])
        setStage('FORM')
        setShow(true)
        suggestionListService.list().then(data => {
            data.sort((a, b) => a.customerName.localeCompare(b.customerName) || a.name.localeCompare(b.name, undefined, { numeric: true }))
			setSuggestionLists(data)
			setResults(data)
		})
    }

    const onHide = () => {
		setShow(false)
    }

    const onSearchQueryChange = e => {
        let value = e.target.value

        setSearchQuery(value)

        let newFilteredSuggestionLists = []
        if (value && value.length > 0) {
			newFilteredSuggestionLists = suggestionLists.filter(list => {
				return list.name.toUpperCase().includes(value.toUpperCase()) || list.customerName.toUpperCase().includes(value.toUpperCase())
			})
        } else {
            newFilteredSuggestionLists = [...suggestionLists]
        }
        //newFilteredSuggestionLists.sort((a, b) => a.customerName.localeCompare(b.customerName) || a.name.localeCompare(b.name))
		setResults(newFilteredSuggestionLists)
    }

    const handleCheck = list => {
        if (selectedLists.includes(list)) {
			var newSelectedLists = selectedLists.filter(otherList => otherList != list)
            setSelectedLists(newSelectedLists)
        } else {
            var newSelectedLists = [...selectedLists, list]
            setSelectedLists(newSelectedLists)
        }
    }

    const handleCheckAll = e => {
        if (selectedLists.length > 0 && results.every(result => selectedLists.includes(result))) {
            setSelectedLists([])
        } else {
            var newSelectedLists = [...results]
            setSelectedLists(newSelectedLists)
        }
    }

    const handleTextChange = e => {
        let value = e.target.value
        setText(value)
    }

    async function submit() {
        setStage('UPDATING')

        var newListUpdateSuccess = {}

		for (var selectedList of selectedLists) {
			var suggestion = {
	            id: uuidv4(),
	            customerId: selectedList.customerId,
	            text: text,
	            imported: false,
	            lat: 1000,
	            lng: 1000
	        }
			selectedList.suggestions.push(suggestion)

			var result = await suggestionListService.update(selectedList.id, selectedList)
			console.log(result)

			newListUpdateSuccess[selectedList.id] = true
			setListUpdateSuccess(newListUpdateSuccess)
		}

		setStage('FINISHED')
    }

    const formatType = function(type) {
        if (type == 'DOCUMENTATION_NAMES') {
            return t('suggestionlist.types.documentationnames')
        } else if (type == 'TASK_OPTIONS') {
            return t('suggestionlist.types.taskoptions')
        } else if (type == 'CONTACT_PERSONS') {
            return t('suggestionlist.types.contactpersons')
        }
        return '-'
    }

	return (
		<>
			<Button
                key="search"
	            onClick={onClick}
	            title="Sök"
	            color="info"
	            variant="outline-dark"
	            style={{float: 'right', marginRight: 5}}>
	            Skapa förslag i flera listor <FontAwesomeIcon icon={faPlus}/>
	        </Button>
			<Modal
				style={{overflow: 'scroll'}}
				size={stage == 'FORM' ? 'xl' : 'md'}
				show={show}
				backdrop={true}
				onShow={() => console.log('onShow')}
				onHide={onHide}
				animation={false}>
				<Modal.Header closeButton>
					<Modal.Title>
						Skapa förslag i flera listor
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{ stage == 'FORM' &&
						<>
							{ suggestionLists.length == 0 &&
								<div style={{textAlign: 'center'}}>
									<Spinner animation="border" role="status">
										<span className="sr-only">Loading...</span>
									</Spinner>
								</div>
							}
							{ suggestionLists.length > 0 &&
								<>
									<Form.Group controlId="text">
						                <Form.Label>
						                    {t('suggestion.columns.text')} *
						                </Form.Label>
						                <Form.Control
						                    required
						                    type="text"
						                    placeholder={t('suggestion.columns.text')}
						                    name="name"
						                    value={text}
						                    onChange={handleTextChange}
						                    style={{width: 300}}
						                    autoFocus
						                />
						            </Form.Group>
									<input
										type="text"
										id="searchQuery"
										className="form-control"
										value={searchQuery}
										onChange={onSearchQueryChange}
										placeholder={'Sök efter listor'}
										style={{width: 300}}
									/>
									{ results.length > 0 &&
										<table className="table table-bordered" style={{marginTop: 10}}>
											<thead>
												<tr>
													<th style={{width: 30}}>
														<Form.Check
								                            id="checkAll"
								                            type="checkbox"
								                            checked={selectedLists.length > 0 && results.every(result => selectedLists.includes(result))}
								                            onChange={handleCheckAll}
								                        />
													</th>
													<th>
														{t('suggestionlist.columns.customer')}
													</th>
													<th>
														{t('suggestionlist.columns.name')}
													</th>
													<th>
														{t('suggestionlist.columns.description')}
													</th>
													<th>
														{t('suggestionlist.columns.type')}
													</th>
												</tr>
											</thead>
											<tbody>
												{ results.map(suggestionList => {
													var suggestionExists = suggestionList.suggestions.some(suggestion => suggestion.text == text)
													return <tr key={suggestionList.id}>
														<td>
															<Form.Check
									                            id={suggestionList.id + '-check'}
									                            type="checkbox"
									                            name={suggestionList.id}
									                            value={suggestionList.id}
									                            checked={selectedLists.includes(suggestionList)}
									                            onChange={e => handleCheck(suggestionList)}
									                            required={selectedLists.length == 0}
									                            disabled={suggestionExists}
									                        />
														</td>
														<td>
															<span style={{color: suggestionExists ? 'lightgray' : 'auto'}}>
																{ suggestionList.customerName }
															</span>
														</td>
														<td>
															<span style={{color: suggestionExists ? 'lightgray' : 'auto'}}>
																{ suggestionList.name }
															</span>
														</td>
														<td>
															<span style={{color: suggestionExists ? 'lightgray' : 'auto'}}>
																{ suggestionList.description || '-' }
															</span>
														</td>
														<td>
															<span style={{color: suggestionExists ? 'lightgray' : 'auto'}}>
																{ formatType(suggestionList.type) }
															</span>
														</td>
													</tr>
												})}
											</tbody>
										</table>
									}
									{ suggestionLists.length > 0 && searchQuery &&
										<div style={{paddingTop: 5}}>
											{ results.length + ' listor hittade, ' + selectedLists.length + ' valda' }
										</div>
									}
								</>
							}
						</>
					}
					{ (stage == 'UPDATING' || stage == 'FINISHED') &&
						<table className="table">
							<tbody>
								{ selectedLists.map(selectedList => {
									return <tr key={'updating-' + selectedList.id}>
										<td>
											{selectedList.name}
										</td>
										<td>
											{ listUpdateSuccess[selectedList.id] == null &&
												<Spinner animation="border" role="status">
													<span className="sr-only">Loading...</span>
												</Spinner>
											}
											{ listUpdateSuccess[selectedList.id] &&
												<FontAwesomeIcon icon={faCheck} style={{color: '#1f6e43'}}/>
											}
										</td>
									</tr>
								})}
							</tbody>
						</table>
					}
				</Modal.Body>
				<Modal.Footer>
					{ stage == 'FORM' &&
						<>
							<Button variant="outline-primary" onClick={onHide}>
								{t('crudtable.cancel')}
							</Button>
							<Button variant="primary" onClick={submit} disabled={text == "" || selectedLists.length == 0}>
								{t('crudtable.ok')}
							</Button>
						</>
					}
					{ stage == 'UPDATING' &&
						<Button variant="primary" onClick={submit} disabled={true}>
							{t('crudtable.ok')}
						</Button>
					}
					{ stage == 'FINISHED' &&
						<Button variant="primary" onClick={e => window.location.reload()}>
							{t('crudtable.ok')}
						</Button>
					}
				</Modal.Footer>
			</Modal>
		</>
	)
}

export default MultiSuggestion